import { configureStore } from '@reduxjs/toolkit';

import { AdministratorsSlice } from './administrators/administrators-slice';
import { CoursesSlice } from './courses/courses-slice';
import { CurricularUnitsSlice } from './curricular-units/curricular-units-slice';
import { DashboardSummarySlice } from './dashboard/dashboard-get-summary.slice';
import { DashboardSlice } from './dashboard/dashboard-slice';
import { EntitiesSlice } from './entities/entities-slice';
import { EvaluationCriteriaSlice } from './evaluation-criteria/evaluation-criteria-slice';
import { QuestionOptionsSlice } from './evaluation-criteria/question-options/question-options-slice';
import { QuestionsSlice } from './evaluation-criteria/questions/questions-slice';
import { GroupsSlice } from './groups/groups-slice';
import { InternshipLocationsSlice } from './internship-locations/internship-locations-slice';
import LayoutReducer from './layouts/reducer';
import { OrganizationsSlice } from './organizations/organizations-slice';
import { PersonSlice } from './person/person-slice';
import { ProfileSlice } from './person/profile/profile-slice';
import { SemestersSlice } from './semesters/semesters-slice';
import { TaskSlice } from './task/task-slice';
import { UsersOnlineSlice } from './users/users-online/users-online-slice';

export const store = configureStore({
  reducer: {
    Layout: LayoutReducer,
    Courses: CoursesSlice.reducer,
    Administrators: AdministratorsSlice.reducer,
    Task: TaskSlice.reducer,
    Course: CoursesSlice.reducer,
    Dashboard: DashboardSlice.reducer,
    Semesters: SemestersSlice.reducer,
    Groups: GroupsSlice.reducer,
    Organizations: OrganizationsSlice.reducer,
    CurricularUnits: CurricularUnitsSlice.reducer,
    DashboardSummary: DashboardSummarySlice.reducer,
    InternshipLocations: InternshipLocationsSlice.reducer,
    EvaluationCriteria: EvaluationCriteriaSlice.reducer,
    Questions: QuestionsSlice.reducer,
    QuestionOptions: QuestionOptionsSlice.reducer,
    Entities: EntitiesSlice.reducer,
    Person: PersonSlice.reducer,
    Profile: ProfileSlice.reducer,
    UsersOnline: UsersOnlineSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
